<template>
  <v-card class="mx-auto text-center" color="#f1f1f1">
    <v-toolbar dense height="32px" flat color="grey lighten-2">
      <v-toolbar-title>Turnover / Area</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click="showChartOptions"></v-app-bar-nav-icon>
    </v-toolbar>

    <v-card-text>
      <canvas ref="myChart" width="100" height="70"></canvas>
    </v-card-text>

    <!-- <v-divider></v-divider>

    <v-card-actions class="justify-center">
      <v-btn block text>Go to Report</v-btn>
    </v-card-actions>-->
  </v-card>
</template>

<script>
import Chart from "chart.js";
import moment from "moment";
import { storeprops } from "@/store/helpers.js";
import DialogChart from "@/components/dashboard/DialogChart";

export default {
  components: { DialogChart },
  data() {
    return {
      showDialog: false,
      obj: new ChartInfo(),
      createChart: undefined,
      refChart: undefined
    };
  },
  computed: {
    ...storeprops
  },
  methods: {
    showChartOptions() {
      this.obj = new ChartInfo();
      this.showDialog = true;
    },
    save(info) {
      this.obj = info;
      this.refChart.destroy();
      let el = this.$refs.myChart;
      this.refChart = this.createChart(info);
    }
  },
  mounted() {
    let el = this.$refs.myChart;
    this.createChart = doCreateChart(el, this.$store);
    this.refChart = this.createChart(this.obj);
  }
};

class ChartInfo {
  graphType = "bar";
  time = "Last12Month";
  dataType = "turnover/month";
}

function getBackgroundColor(index) {
  const backgroundColor = [
    "rgba(255, 99, 132, 0.2)",
    "rgba(54, 162, 235, 0.2)",
    "rgba(255, 206, 86, 0.2)",
    "rgba(75, 192, 192, 0.2)",
    "rgba(153, 102, 255, 0.2)",
    "rgba(255, 159, 64, 0.2)"
  ];
  if (index >= backgroundColor.length) index = backgroundColor.length - 1;
  return backgroundColor[index];
}

const doCreateChart = (el, store) => {
  return info => {
    let cities = store.getters.getCities("Last12Month");
    let profitsPerCity = cities.map(city =>
      store.getters.getInvoicedByArea(city, "Last12Month")
    );

    return new Chart(el, {
      type: "doughnut",
      data: {
        labels: cities,
        datasets: [
          {
            data: profitsPerCity,
            backgroundColor: function(context) {
              var index = context.dataIndex;
              var value = context.dataset.data[index];
              if (value < 0) return "red";
              return getBackgroundColor(index);
            }
          }
        ]
      },
      options: {
        legend: {
          display: true,
          position: "right"
        }
      }
    });
  };
};

// const doCreateChart = el => {
//   //var ctx = document.getElementById("myChart");
//   var myChart = new Chart(el, {
//     type: "doughnut",
//     data: {
//       labels: ["Staines", "Sunbury on ", "Kingston"],
//       datasets: [
//         {
//           data: [10, 20, 30],
//           // backgroundColor: [
//           //   "rgba(255, 99, 132, 0.2)",
//           //   "rgba(54, 162, 235, 0.2)",
//           //   "rgba(255, 206, 86, 0.2)",
//           //   "rgba(75, 192, 192, 0.2)",
//           //   "rgba(153, 102, 255, 0.2)",
//           //   "rgba(255, 159, 64, 0.2)"
//           // ],
//           backgroundColor: function(context) {
//             var index = context.dataIndex;
//             var value = context.dataset.data[index];
//             return value < 0
//               ? "red" // draw negative values in red
//               : index % 2
//               ? "blue" // else, alternate values in blue and green
//               : "green";
//           }
//         }
//       ]
//     },

//     // backgroundColor: function(context) {
//     //   var index = context.dataIndex;
//     //   var value = context.dataset.data[index];
//     //   return value < 0
//     //     ? "red" // draw negative values in red
//     //     : index % 2
//     //     ? "blue" // else, alternate values in blue and green
//     //     : "green";
//     // },
//     // color: [
//     //   "red", // color for data at index 0
//     //   "blue", // color for data at index 1
//     //   "green", // color for data at index 2
//     //   "black" // color for data at index 3
//     // ],
//     options: {
//       legend: {
//         display: true,
//         position: "right"
//       }
//     }
//   });
// };
</script>

<style>
</style>